import React from 'react';
import moment from 'moment';

import EventIcon from './event-icon';
import style from './index.less';

const phoneCheckTextMap = {
  '0': '空号',
  '1': '正常',
  '2': '停机',
  '3': '空号',
  '4': '沉默号',
  '5': '风险号'
};

const phoneCheckColorMap = {
  '0': '#ff4236',
  '1': '#15c292',
  '2': '#ff8806',
  '3': '#ff4236',
  '4': '#1880ff',
  '5': 'black'
};

const MessageEventEvalution = props => {
  const { data } = props;
  const { action, content, time, agentName } = data;
  const { area, status, tel } = content;
  const date = moment
    .utc(time)
    .local()
    .format('MM/DD HH:mm:ss');

  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action={action} />
        </li>
        <li className={style.date}>{date}</li>
        <li>{agentName}</li>
        <li>空号检测</li>
        <li>{`(${tel})`}</li>
      </ul>
      <div className={style['event-border']} />
      <div className={style['evaluation-content']}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div>{`检测结果：`}</div>
            <div
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: phoneCheckColorMap[status]
              }}
            ></div>
            <div style={{ marginLeft: '3px' }}>{phoneCheckTextMap[status]}</div>
          </div>
          <div style={{ marginLeft: '20px' }}>{`号码归属地：${area}`}</div>
        </div>
      </div>
    </div>
  );
};

export default MessageEventEvalution;
